import React from 'react';
import edgeLogo from '../../../assets/images/edge_logo-removebg.png';
import './ExalogicLogo.css';

const ExalogicLogo = ({ className = "", theme = "dark" }) => {
    return (
        <div className={`exalogic-logo-container ${className} theme-${theme}`}>
            <img src={edgeLogo} alt="EDGE Logo" className="exalogic-logo-img" style={{ maxHeight: '100%', objectFit: 'contain' }} />
        </div>
    );
};

export default ExalogicLogo;

